import i18n from "locales/i18n";
import api from "./api";
const langCd = i18n.language;

// 숙소그룹리스트
export const lodGrpsApi = async () => {
  const res = await api({
    method: "get",
    url: "lod/lodGrpList",
  });

  return res;
};

//매니저 숙소 리스트
export const lodListApi = async () => {
  const res = await api({
    method: "get",
    url: `/lod/lodList`,
  });

  return res;
};

//객실타입
export const rmTypApi = async () => {
  const res = await api({
    method: "get",
    url: `code/lodCdList/${langCd}/RT`,
  });

  return res;
};

//객실전망
export const rmOlkApi = async () => {
  const langCd = i18n.language;
  const res = await api({
    method: "get",
    url: `code/lodCdList/${langCd}/RV`,
  });

  return res;
};

//침대종류
export const rmBedTypApi = async () => {
  const langCd = i18n.language;
  const res = await api({
    method: "get",
    url: `code/lodCdList/${langCd}/RB`,
  });

  return res;
};

// 객실리스트
export const rmListApi = async (params: { langCd: string; lodNo: string }) => {
  const res = await api({
    method: "get",
    url: `rm/rmList/${params.langCd}/${params.lodNo}`,
  });

  return res;
};

//객실옵션리스트
export const rmOpListApi = async (rmNo: string) => {
  const res = await api({
    method: "get",
    url: `rmOp/rmOpList/${rmNo}`,
  });

  return res;
};
